import { useEffect, useState } from "react";
import {
  getPortalClientName,
  isClientBranded,
} from "../../helpers/clientHelper";
import { useAuth } from "../../contexts/AuthContext";

const FooterCopyRight = (footerProps) => {
  const { loggedinUser } = useAuth();
  const [loadingComponents, setLoadingComponents] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoadingComponents(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* ============== Copyright Section Start ============== */}
      {loadingComponents && (
        <div
          className={` ${
            footerProps.isBorder == true
              ? `bg-footer copyr ight-border`
              : "bg-light"
          }  text-default p y-2`}
        >
          <div
            className={`py-2 ${
              footerProps.isBorder == true
                ? "container"
                : "container-fluid box-shadow-top bo-t1-gray"
            }`}
            style={{ height: "40px" }}
          >
            <div className="row">
              <div className={`col ${footerProps?.css}`}>
                <span
                  className={`${
                    footerProps.isBorder == true
                      ? "text-white"
                      : "text-light-dark-color font-500 font-small"
                  }`}
                >
                  © {new Date().getFullYear()}{" "}
                  {getPortalClientName() || "Assets Watch"}. All rights reserved.
                  {/* Client portals show only the client logo in the header, so credit AssetsWatch here. */}
                  {isClientBranded(loggedinUser) && (
                    <>
                      <span style={{ margin: "0 10px" }}>|</span>
                      <a
                        href="https://assetswatch.com"
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: "inherit" }}
                      >
                        Powered by AssetsWatch
                      </a>
                    </>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* ============== Copyright Section End ============== */}
    </>
  );
};

export default FooterCopyRight;
